import * as _ from 'lodash-es'
import { IFeatureContainer } from '@/classes/components/feature/IFeatureContainer'
import { IOrganizationData } from '../../../../interface'
import { Pilot } from '../../Pilot'
import Organization from './Organization'
import { IReserveData, Reserve } from './Reserve'

interface IReservesSaveData {
  reserves: IReserveData[]
  orgs: IOrganizationData[]
}

class ReservesController implements IFeatureContainer {
  public readonly Parent: Pilot

  private _reserves: Reserve[]
  private _orgs: Organization[]

  public constructor(parent: Pilot) {
    this.Parent = parent
    this._reserves = []
    this._orgs = []
  }

  get FeatureSource(): any[] {
    return this.Reserves
  }

  public get Reserves(): Reserve[] {
    return this._reserves
  }

  public set Reserves(reserves: Reserve[]) {
    this._reserves = reserves
    this.Parent.SaveController.save()
  }

  public AddReserve(reserve: Reserve): void {
    reserve.SetPilot(this.Parent)
    this._reserves.push(reserve)
    reserve.Bonuses.filter(x => x.ID === "mount_modification").forEach(
      x => this.Parent.UpdateMechMounts(x, true)
    )
    this.Parent.SaveController.save()
  }

  public RemoveReserve(index: number): void {
    const removedReserve = this._reserves.splice(index, 1)[0]
    removedReserve.Bonuses.filter(
      x => x.ID === "mount_modification").forEach(
      x => this.Parent.UpdateMechMounts(x, false))
    this.Parent.SaveController.save()
  }

  public get Organizations(): Organization[] {
    return this._orgs
  }

  public set Organizations(orgs: Organization[]) {
    this._orgs = orgs
    this.Parent.SaveController.save()
  }

  public AddOrganization(org: Organization): void {
    org.SetPilot(this.Parent)
    this._orgs.push(org)
    this.Parent.SaveController.save()
  }

  public RemoveOrganization(index: number): void {
    this._orgs.splice(index, 1)
    this.Parent.SaveController.save()
  }

  public static Serialize(parent: Pilot, target: any) {
    target.reserves = parent.ReservesController.Reserves.length
      ? parent.ReservesController.Reserves.map(x => Reserve.Serialize(x))
      : []

    target.orgs = parent.ReservesController.Organizations.length
      ? parent.ReservesController.Organizations.map(x => Organization.Serialize(x))
      : []
  }

  public static Deserialize(parent: Pilot, data: IReservesSaveData) {
    if (!parent.ReservesController)
      throw new Error(
        `ReservesController not found on parent (${typeof parent}). New ReservesControllers must be instantiated in the parent's constructor method.`
      )

    parent.ReservesController._reserves = data.reserves
      ? data.reserves.map((x: IReserveData) => {
          const r = Reserve.Deserialize(x)
          r.SetPilot(parent)
          return r
        })
      : []

    parent.ReservesController._orgs = data.orgs
      ? data.orgs.map((x: IOrganizationData) => {
          const o = Organization.Deserialize(x)
          o.SetPilot(parent)
          return o
        })
      : []
  }
}

export { ReservesController }
export type { IReservesSaveData }
